<script lang="ts">
  import { AppState } from '../../etc/stores';

  const { primary600 } = $AppState.theme.colors;
</script>

<svg
  width="100%"
  viewBox="0 0 768 159"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    opacity="0.8"
    d="M0 20C0 8.95431 8.9543 0 20 0H748C759.046 0 768 8.95431 768 20V159L438.877 89.6072C402.69 81.9775 365.31 81.9775 329.123 89.6072L0 159V20Z"
    fill={primary600}
  />
</svg>
